import update from 'immutability-helper';
import {isEmpty} from 'lodash';
import {useMemo} from 'react';

import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {
  injectDashboardDates,
  useDashboardDates,
} from '../../../utils/dashboardDate';
import {
  BeltLocationHistory,
  getBeltLocationHistoryReportData,
} from './BeltLocationHistoryReport';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}

export interface BeltLocationTrackingReportData {
  viewType: 'beltLocationHistoryReport';
  title: string;
  beltLocationHistoryReport: any;
}

const getBeltLocationTrackingReports = (): BeltLocationTrackingReportData => ({
  viewType: 'beltLocationHistoryReport',
  title: 'Belt Location History Report',
  beltLocationHistoryReport: getBeltLocationHistoryReportData(),
});

export const BeltLocationHistoryReport = ({value, onUpdate}: Props) => {
  const config = useMemo(
    () =>
      !isEmpty(value)
        ? (value as BeltLocationTrackingReportData)
        : getBeltLocationTrackingReports(),
    [value]
  );

  const dashboardDates = useDashboardDates(value?.detachedFromDashboardDate);

  const beltLocationValue = useMemo(() => {
    const base = config.beltLocationHistoryReport;
    if (!dashboardDates || !base?.openedItems) {
      return base;
    }
    const newItems = injectDashboardDates(base.openedItems, dashboardDates);
    if (newItems === base.openedItems) {
      return base;
    }
    return {...base, openedItems: newItems};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    config.beltLocationHistoryReport,
    dashboardDates?.date_start,
    dashboardDates?.date_end,
  ]);

  return (
    <BeltLocationHistory
      value={beltLocationValue}
      onUpdate={(v) => {
        let detach = false;
        if (
          dashboardDates &&
          v?.openedItems &&
          v.openedItems.length ===
            config.beltLocationHistoryReport?.openedItems?.length
        ) {
          const activeIdx = v.openedItems.findIndex(
            (it: any) =>
              it.id ===
              (v.activeId ?? config.beltLocationHistoryReport?.activeId)
          );
          const incoming =
            activeIdx >= 0 ? v.openedItems[activeIdx] : undefined;
          if (
            incoming &&
            (incoming.params?.date_start !== dashboardDates.date_start ||
              incoming.params?.date_end !== dashboardDates.date_end)
          ) {
            detach = true;
          }
        }
        const base = update(value ?? getBeltLocationTrackingReports(), {
          beltLocationHistoryReport: {
            $set: v ?? getBeltLocationHistoryReportData(),
          },
        });
        onUpdate?.(detach ? {...base, detachedFromDashboardDate: true} : base);
      }}
    />
  );
};
